<template>
  <div class="ManageDistributors">
    <el-container style="margin-top: 3rem;">
      <el-header>
        <h1>待审核加盟经销商</h1>
      </el-header>

      <el-main>
        <el-table
          :data="paginatedDistributors"
          v-if="distributors.length > 0"
          style="width: 100%;"
        >
          <el-table-column prop="username" label="用户名" width="150"></el-table-column>
          <el-table-column prop="realName" label="真实姓名" width="150"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="200"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
          <el-table-column prop="address" label="联系地址" width="300"></el-table-column>

          <el-table-column prop="hasTaobao" label="是否有淘宝店" width="150">
            <template #default="scope">
              <el-tag :type="scope.row.hasTaobao === 'yes' ? 'success' : 'info'">
                {{ scope.row.hasTaobao === 'yes' ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="taobaoName" label="淘宝店铺名称" width="200"></el-table-column>
          <el-table-column prop="taobaoLink" label="淘宝店铺链接" width="300">
            <template #default="scope">
              <a
                v-if="scope.row.taobaoLink"
                :href="scope.row.taobaoLink"
                target="_blank"
                style="color:#409EFF"
              >
                {{ scope.row.taobaoLink }}
              </a>
              <span v-else>—</span>
            </template>
          </el-table-column>

          <el-table-column prop="taobaoActive" label="淘宝是否正常经营" width="180">
            <template #default="scope">
              <el-tag :type="scope.row.taobaoActive === 'yes' ? 'success' : 'danger'">
                {{ scope.row.taobaoActive === 'yes' ? '正常' : '异常/未填写' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="invest" label="预计投资金额区间" width="180"></el-table-column>

          <el-table-column prop="familySupport" label="家人是否支持" width="150">
            <template #default="scope">
              <el-tag :type="scope.row.familySupport === 'yes' ? 'success' : 'danger'">
                {{ scope.row.familySupport === 'yes' ? '支持' : '不支持' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="identityType" label="加盟身份类型" width="180">
            <template #default="scope">
              <el-tag :type="scope.row.identityType === 'person' ? 'info' : 'success'">
                {{ scope.row.identityType === 'person' ? '个人' : '企业' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="hasLicense" label="是否已注册营业执照" width="180">
            <template #default="scope">
              <el-tag :type="scope.row.hasLicense === 'yes' ? 'success' : 'info'">
                {{ scope.row.hasLicense === 'yes' ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="bizName" label="个体工商户名称" width="200"></el-table-column>
          <el-table-column prop="bizCode" label="营业执照信用代码" width="200"></el-table-column>

          <el-table-column prop="promissName" label="制卡权限组" width="150">
            <template #default="scope">
              <el-tag :type="scope.row.promissID === '0' ? 'success' : 'info'">
                {{ scope.row.promissID === '0' ? '无限制卡权' : scope.row.promissName }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="注册时间" width="200" sortable></el-table-column>

          <!-- 状态显示 -->
          <el-table-column prop="types" label="审核状态" width="150">
            <template #default="scope">
              <el-tag :type="scope.row.types === '0' ? 'success' : 'warning'">
                {{ scope.row.types === '0' ? '已通过' : '待审核' }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <el-button
                @click="toggleBan(scope.row)"
                type="primary"
                size="small"
              >
              通过审核
              </el-button>

              <el-button
                @click="toggleBans(scope.row)"
                type="danger"
                size="small"
              >
              驳回审核
              </el-button>

            </template>
          </el-table-column>
        </el-table>

        <div v-else>
          <el-empty description="暂无待审核经销商"></el-empty>
        </div>

        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalPages * pageSize"
          :page-size="pageSize"
          v-model:currentPage="currentPage"
          @current-change="fetchDistributors"
          style="margin-top: 20px; text-align: center;"
        ></el-pagination>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from '../axios';
import { ElMessage } from '@/plugins/tdesignElementAdapter';

export default {
  name: 'ManageDistributors',
  data() {
    return {
      distributors: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    paginatedDistributors() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.distributors.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.distributors.length / this.pageSize);
    },
  },
  created() {
    this.fetchDistributors();
  },
  methods: {
    async fetchDistributors() {
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=getDistributorsApply', { token });
        this.distributors = response.data.distributors || [];
      } catch (error) {
        console.error('Error fetching distributors:', error);
        this.distributors = [];
      }
    },

    async toggleBan(distributor) {
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=toggleDistributorBanApply', {
          token,
          username: distributor.username,
        });
        if (response.data.success) {
          ElMessage.success('审核状态已更新');
          await this.fetchDistributors();
        } else {
          ElMessage.error(response.data.message);
        }
      } catch (error) {
        console.error('Error toggling ban:', error);
        ElMessage.error('操作失败，请稍后重试');
      }
    },


    async toggleBans(distributor) {
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=toggleDistributorBansApply', {
          token,
          username: distributor.username,
        });
        if (response.data.success) {
          ElMessage.success('审核状态已更新');
          await this.fetchDistributors();
        } else {
          ElMessage.error(response.data.message);
        }
      } catch (error) {
        console.error('Error toggling ban:', error);
        ElMessage.error('操作失败，请稍后重试');
      }
    },
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .el-table {
    font-size: 14px;
  }

  .el-table th,
  .el-table td {
    padding: 10px 5px;
  }

  .el-pagination {
    margin: 10px 0;
  }
}
</style>
